import { FC } from "react";
import { AlertModalProps } from "./AlertModal";
import { ModalForm } from "./ModalForm";

const ObjectModal: FC<ObjectModalProps> = (props) => {
    return <>
        {props.alertModal?.message !== undefined && (
            <ModalForm
                validationSchema={props.alertModal?.validationSchema}
                initialValues={props.alertModal.initialValues}
                innerHTML={props.alertModal.innerHTML}
                addButton={props.alertModal.colum?.length > 0 ? props.addColumn : undefined}
                setAGGridRef={props.setGridRef}
                isRefreshGrid={props.refreshAGGrid}
                modalFullscreen={props.alertModal.modalFullscreen}
                message={props.alertModal?.message}
                show={props.alertModal?.message !== undefined}
                closeName={props.alertModal?.closeName}
                maxLength={props.alertModal?.maxLength}
                title={props.alertModal?.title}
                saveName={props.alertModal?.saveName}
                showSave={props.alertModal.showSave}
                rows={props.alertModal.rows}
                hideGrid={props.alertModal.hideGrid}
                showClose={props.alertModal?.showClose}
                arrayInput={props.alertModal?.arrayInput}
                showAddButton={props.alertModal?.showAddButton}
                onGridReady={(params: any) => { }}
                close={props.alertModal?.close}
                colum={props.alertModal.colum}
                save={props.alertModal.save}
                showSecondAction={props.alertModal.showSecondAction}
                secondActionName={props.alertModal.secondActionName}
                secondAction={props.alertModal.secondAction}
                showThirdAction={props.alertModal.showThirdAction}
                thirdActionName={props.alertModal.thirdActionName}
                thirdAction={props.alertModal.thirdAction}
                rowSelection={props.alertModal.rowSelection}
                suppressRowClickSelection={props.alertModal.suppressRowClickSelection}
                onClick={props.alertModal.onClick}
                onChange={props.alertModal.onChange}
            />
        )}
    </>
}
export interface ObjectModalProps {
    alertModal: AlertModalProps | undefined,
    addColumn?: any,
    setGridRef?: any,
    refreshAGGrid?: any
}
export { ObjectModal }